import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton
} from '@chakra-ui/react';
const CustomModalLink = ({ showModalButtonText, modalHeader, modalBody,isOpenEdit, onOpenEdit, onCloseEdit}) => {
  
  return (
    <>
     

      <Modal isOpen={isOpenEdit} size='xl' onClose={onCloseEdit}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{modalHeader}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {modalBody}

            
          </ModalBody>

          
        </ModalContent>
      </Modal>
    </>
  );
};

export default CustomModalLink;